export function updateEntitySchemaForTrackingUrlTemplate(entitySchema) {
  const entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.TrackingUrlTemplate.operators
  = ['contains', 'doesnotcontain', 'startswith', 'eq'];

  return entitySchemaCopy;
}
